import React from 'react';
import { IPaymentTerm } from '../../../../../../store/ducks/long-steel-shopping-cart/types';
import { Select } from '@gerdau/hefesto/Select';

interface IPaymentWaySelectProps {
  selectedTerm: string;
  paymentTerms: IPaymentTerm[];
  onSelectTerm(term: string): void;
  disabled: boolean;
}

const PaymentWaySelect: React.FC<IPaymentWaySelectProps> = ({
  paymentTerms,
  selectedTerm,
  onSelectTerm,
  disabled
}) => {
  const paymentTermsOptions = paymentTerms.map((paymentTerm) => ({
    label: paymentTerm.description,
    value: paymentTerm.term
  }));

  return (
    <Select
      label=""
      hideLabel
      name="paymentWaySelect"
      disabled={disabled}
      options={paymentTermsOptions}
      value={selectedTerm}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onSelect={(selectedPaymentTerm: any) => onSelectTerm(selectedPaymentTerm)}
    />
  );
};

export default PaymentWaySelect;
